import React, { useEffect } from "react";
import Marquee from "react-fast-marquee";
import aboutBg from "../../images/bg/about-bg.png";
import VideoCarousel from "../VideoCarousel/VideoCarousel";

// About images (3–4 images)
import img01 from "../../images/about/img01.jpg";
import img02 from "../../images/about/img02.jpg";
import img03 from "../../images/about/img03.jpg";
import { Link } from "react-router-dom";


const AboutSection: React.FC = () => {
  useEffect(() => {
    const bgEl = document.querySelector<HTMLElement>(".xb-about-img-wrap");
    if (bgEl) bgEl.style.backgroundImage = `url(${aboutBg})`;
  }, []);

  const aboutImages = [img01, img02, img03];

  return (
    <section className="about pt-140">
      <div className="container">
        <div className="sec-title about-sec-title mb-75">
          <span className="sub-title">Who We Are?</span>
          {/* Content for Homepage.pdf — Slide 4 */}
          <h2 className="title">
            One universe. Ten worlds. Five missions. A single purpose.
          </h2>
          <p className="content mt-25">
            We build an integrated ecosystem of companies, platforms and
            institutions that thrive in the Intelligent Era.
          </p>
        </div>
      </div>

      {/* 633x455 image carousel — filhal comment (user request) */}
      {/*
      <div className="xb-about-img-wrap bg_img wow">
        <Marquee speed={40} gradient={false} pauseOnHover={false}>
          {aboutImages.map((img, idx) => (
            <div key={idx} className="xb-about-img-item img-hove-effect">
              <div className="xb-img">
                <Link to="/service-details">
                  <img src={img} alt={`about-${idx + 1}`} />
                </Link>
              </div>
            </div>
          ))}
        </Marquee>
      </div>
      */}

      {/* 🎬 Video carousel — filhal comment (user request) */}
      {/* <VideoCarousel /> */}
    </section>
  );
};

export default AboutSection;
